<script>
	import CustomInput from "src/components/CustomInput/CustomInput.svelte";
	import CustomSearch from "src/components/CustomSearch/CustomSearch.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let zendeskTicketId;
	export let linkToCases;

	function mapToValues(arr) {
		if (arr && arr.length)
			return arr.map((item) => ({ value: item, label: item }));
		else return null;
	}
</script>

<Col xs={5}>
	<Row class="mb-4">
		<Col>
			<Row>
				<Col>
					<label for="zendeskTicketId" class="d-block">
						<span> Zendesk Ticket ID </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						type="text"
						bind:value={$zendeskTicketId.value}
						maxlength={100}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
	<Row class="mb-4">
		<Col>
			<Row>
				<Col>
					<label for="linkToCases" class="d-block">
						<span> Link to existing case(s) </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomSearch
						isCreatable={true}
						isMulti={true}
						type="text"
						placeholder="Search case number"
						isSearchable
						onSelect={(e) => {
							$linkToCases.value =
								e.detail && e.detail.map((i) => i.value);
						}}
						isClearable
						value={mapToValues($linkToCases.value) || null}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
</Col>
